import * as React from 'react'
import { injectIntl } from 'react-intl'
import RecordTable from './index'
import FlexTable from './flex-table'
import BoD1Table from './BoD1Table'
import { RecordTableContainerProp } from './interface'
import QueryLessonHistory from './QueryLessonHistory'
import { useSelector } from 'react-redux'
import { StoreProps } from '@interfaces/StoreState'

const RecordTableContainer: React.FunctionComponent<RecordTableContainerProp> = ({
  fromDate,
  endDate,
  learningPaths,
  students,
  profile,
  isFlex,
  isBoD1,
  isLiveCoachingSession,
  title,
  displayLessonsBtn = true,
  currentInstructor = false,
  language,
  units,
  ProgramIds = [],
}) => {
  const options = students.map(({ StudentName, CustomerId }) => ({
    label: StudentName,
    value: CustomerId,
    key: CustomerId,
  }))
  const { userProfile } = useSelector(
    ({ userProfile }: StoreProps) => ({
      userProfile: userProfile.info,
    })
  )

  return (
    <QueryLessonHistory
      fromDate={fromDate}
      endDate={endDate}
      learningPaths={learningPaths}
      students={students}
      fetchFlex={isFlex}
      fetchLCS={isLiveCoachingSession}
      fetchBoD1={isBoD1}
      currentInstructor={currentInstructor}
      language={language}
      ProgramIds={ProgramIds}
      userProfile={userProfile}
    >
      {({ loading, data, student, setStudent, setData }) => {
        if (isFlex) {
          return (
            <FlexTable
              title={title}
              instructor={profile}
              lessonHistory={data}
              setLessonHistory={setData}
              setStudent={setStudent}
              students={students}
              options={options}
              selectedStudent={student}
              loading={loading}
              displayLessonsBtn={displayLessonsBtn}
              units={units}
            />
          )
        }

        if (isBoD1) {
          return (
            <BoD1Table
              title={title}
              instructor={profile}
              lessonHistory={data}
              setLessonHistory={setData}
              setStudent={setStudent}
              students={students}
              options={options}
              selectedStudent={student}
              loading={loading}
              displayLessonsBtn={displayLessonsBtn}
              units={units}
            />
          )
        }

        return (
          <RecordTable
            title={title}
            instructor={profile}
            lessonHistory={data}
            setLessonHistory={setData}
            setStudent={setStudent}
            students={students}
            options={options}
            selectedStudent={student}
            loading={loading}
            displayLessonsBtn={displayLessonsBtn}
          />
        )
      }}
    </QueryLessonHistory>
  )
}

export default injectIntl(RecordTableContainer)
